require './account'

App.Partner = App.Account.extend
  name: DS.attr 'string'
  partnership: DS.belongsTo 'partnership', async: true
